import Section from "./Section";
import Group54 from "../../../assets/Group54.png";
import Group56 from "../../../assets/Group56.png";
import Group55 from "../../../assets/Group55.png";

const Features = () => {
  return (
    <>
      <Section
        serial="first"
        bgColor="#FFFFFF"
        text="Track finances with ease using our cash register"
        imgSrc={Group54}
      />
      <Section
        serial="second"
        bgColor="#EEF6FF"
        text="Say goodbye to paper trails with our digital fee collection system"
        imgSrc={Group56}
      />
      <Section
        serial="third"
        bgColor="#FFFFFF"
        text="Elevate your academy's financial management to the next level"
        imgSrc={Group55}
      />
    </>
  );
};

export default Features;